export const handleErrorsMdfe = (error) => {
  if (!error) return null;

  if (typeof error === "object") {
    const validationMessage = error.erros?.[0]
      ? Object.values(error.erros[0])[0]
      : null;

    if (validationMessage) {
      return {
        message: validationMessage,
        nameError: "Validation failed",
      };
    }

    error = error.message || JSON.stringify(error);
  }

  const cleanMessage = String(error).replace(/^Error:\s*/, "").trim();

  if (cleanMessage.includes("ERROR_NAME")) {
    const [name, ...message] = cleanMessage.split("-");
    return {
      message: message.join("-").trim(),
      nameError: name.split(":").pop().trim(),
    };
  }

  if (
    cleanMessage &&
    !cleanMessage.includes("Request failed with status code")
  ) {
    return {
      message: cleanMessage.replace(/^NOT_ALLOWED:\s*/, ""),
      nameError: "BusinessError",
    };
  }

  return null;
};
